import { MAIN_CONTENT_ID } from './skip-link';

/**
 * Moves focus to the page's main content (`MAIN_CONTENT_ID`, else `<main>`)
 * without scrolling. For when the focused element is about to disappear --
 * a route change, or the reader swapping views -- so focus lands on the new
 * content instead of falling back to <body>.
 *
 * Leaves focus alone when it's already inside the content. Returns whether
 * focus is now in the content, so a caller waiting on a lazy view can retry:
 * while a view suspends, the outgoing one's container is still in the DOM
 * but hidden (`display: none`), and focusing it fails silently.
 */
export function focusMainContent(): boolean {
	const target =
		document.getElementById(MAIN_CONTENT_ID) ?? document.querySelector('main');
	if (!target || target.getClientRects().length === 0) {
		return false;
	}
	if (target.contains(document.activeElement)) {
		return true;
	}
	if (!target.hasAttribute('tabindex')) {
		target.setAttribute('tabindex', '-1');
	}
	// Scroll position belongs to the router (`scrollRestoration`).
	target.focus({ preventScroll: true });
	return document.activeElement === target;
}
